import api from "$services/api";

const featureFlagsApi = {
    getFlags: (signal) => api.get("/api/admin/feature-flags", null, { signal }),
    toggleFlag: (id, enabled) => api.put(`/api/admin/feature-flags/${id}`, { enabled }),
};

export default featureFlagsApi;
